import { TipoItem, Udm, Moneda } from "../../reductores/Constantes";

const TipoDeItem = {};
TipoDeItem[TipoItem.PlanInternet] = "Plan.Int.";
TipoDeItem[TipoItem.ServiciosGen] = "Serv. Gen.";
TipoDeItem[TipoItem.Articulo] = "Articulo";
    
const UnidadDeItem = {}
UnidadDeItem[Udm.Mensual] = "Mensual";
UnidadDeItem[Udm.Unidad] = "Unid.";
/* const TipoDeItem = {
    planInt: "Plan.Int.",
    servGen: "Serv. Gen.",
    art: "Articulo"
}; */

/* const UnidadDeItem = {
    mensual: "Mensual",
    unid: "Unid.",
}; */

const EstadosDelItem = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};


export { EstadosDelItem, UnidadDeItem, TipoDeItem };
